module.exports = {"TXTWCL_Converted_Limit":{"id":"TXTWCL_Converted_Limit","defaultMessage":"Omvekslet grænse"}}